import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es";
import { SidebarProvider, useSidebar } from "./context/SidebarContext";
import SideBar from "./components/SideBar";
import ToolBar from "./components/ToolBar";
import {
  LayoutContainer,
  MainContent,
  SideBarWrapper,
  ContentWrapper
} from "./styles/LayoutStyles";

interface ProjectLayoutProps {
  children: React.ReactNode;
}

export default function ProjectLayout(props: ProjectLayoutProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <SidebarProvider>
        <E>{props.children}</E>
      </SidebarProvider>
    </LocalizationProvider>
  );
}

const E = ({ children }: { children: React.ReactNode }) => {
  const { mainContent, sideBarRef, handleClickOutside } = useSidebar();
  return (
    <LayoutContainer onClick={(event: any) => handleClickOutside(event!)}>
      <SideBarWrapper id="side-bar" ref={sideBarRef}>
        <SideBar />
      </SideBarWrapper>
      <MainContent ref={mainContent}>
        <ToolBar />
        <ContentWrapper>{children}</ContentWrapper>
      </MainContent>
    </LayoutContainer>
  );
};
